import styled, { css } from "styled-components";

const sharedStyle = css`
  width: 23%;
`;

export const CheckoutItemContainer = styled.div`
  width: 100%;
  display: flex;
  min-height: 100px;
  border-bottom: 1px solid darkgrey;
  padding: 15px 0;
  font-size: 20px;
  align-items: center;
`;

export const ImageContainer = styled.div`
  width: 23%;
  padding-right: 15px;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const Name = styled.span`
  ${sharedStyle}
`;
export const Quentity = styled.span`
  display: flex;
  ${sharedStyle}
  text-align:center
`;
export const Price = styled.span`
  ${sharedStyle}
`;
export const Value = styled.span`
  margin: 0 10px;

  ${sharedStyle}
`;
export const Arrow = styled.div`
  cursor: pointer;
`;

export const RemoveButton = styled.div`
  padding-left: 12px;
  cursor: pointer;
`;
